export default __webpack_public_path__ + "static/media/linkedin.2eda7bdd.svg";